module.exports = __webpack_public_path__ + "img/25.50604634.jpg";